import * as Amplitude from "@amplitude/analytics-browser"

/**
 * User updated post.
 */
export function postUpdated(
  postId: string,
  isPublished: boolean,
  updatedFields: string[]
) {
  return Amplitude.track("post_updated", {
    post_id: postId,
    published: isPublished,
    updated_fields: updatedFields,
  })
}

/**
 * User created a draft.
 */
export function draftCreated(postId: string, updatedFields: string[]) {
  return Amplitude.track("draft_created", {
    post_id: postId,
    updated_fields: updatedFields,
  })
}

/**
 * User used AI generation.
 */
export function generatedWithAI(postId: string, type: string) {
  return Amplitude.track("generated_with_ai", {
    post_id: postId,
    type,
  })
}

/**
 * User changed collectible image.
 */
export function collectibleImageChanged(postId: string) {
  return Amplitude.track("collectable_image_changed", {
    post_id: postId,
  })
}
